// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertEventKind {
	Opened = 0,
	Acknowledged = 1,
	Resolved = 2,
	FlapSuppressed = 3,
	NotificationDispatched = 4,
	NotificationSucceeded = 5,
	NotificationFailed = 6,
	ConditionStillPresent = 7,
	Reopened = 8,
}

export const AlertEventKindDisplayNames: { [key in keyof typeof AlertEventKind]?: string} = {
	"Opened": "Opened",
	0 : "Opened",
	"Acknowledged": "Acknowledged",
	1 : "Acknowledged",
	"Resolved": "Resolved",
	2 : "Resolved",
	"FlapSuppressed": "FlapSuppressed",
	3 : "FlapSuppressed",
	"NotificationDispatched": "NotificationDispatched",
	4 : "NotificationDispatched",
	"NotificationSucceeded": "NotificationSucceeded",
	5 : "NotificationSucceeded",
	"NotificationFailed": "NotificationFailed",
	6 : "NotificationFailed",
	"ConditionStillPresent": "ConditionStillPresent",
	7 : "ConditionStillPresent",
	"Reopened": "Reopened",
	8 : "Reopened",
}

export const getAlertEventKindDisplayName = (key: AlertEventKind | (keyof typeof AlertEventKind & string)) => {
	return AlertEventKindDisplayNames[key];
}

